// @flow
import { WebStorage } from 'redux-persist';
import { KEY_PREFIX, REHYDRATE } from 'redux-persist/lib/constants';
import { type Store } from 'redux';

type CrosstabConfig = {
  key: string,
  blacklist?: ?Array<string>,
  keyPrefix?: ?string,
  whitelist?: ?Array<string>,
  dataCheck?: ?Function,
};

const crossTabEventFunction = function(
  store: Store<any, any>,
  storage: WebStorage,
  configArray: CrosstabConfig[]
) {
  window.addEventListener('storage', handleStorageEvent, false);

  function handleStorageEvent(e) {
    configArray.forEach(config => {
      const blacklist: ?Array<string> = config.blacklist || null;
      const whitelist: ?Array<string> = config.whitelist || null;
      const keyPrefix: string = config.keyPrefix || KEY_PREFIX;
      if (e.key && e.key.indexOf(keyPrefix) === 0) {
        if (e.oldValue === e.newValue) return;

        const newState: Object = stateReducer(
          JSON.parse(e.newValue),
          whitelist,
          blacklist
        );
        if (config.dataCheck) {
          const oldState: Object = stateReducer(
            JSON.parse(e.oldValue),
            whitelist,
            blacklist
          );
          // $FlowIgnore - because I am checking if dataCheck exists above already!
          if (config.dataCheck(oldState, newState)) return;
        }

        store.dispatch({
          key: config.key,
          payload: newState,
          type: REHYDRATE,
        });
      }
    });
  }
};

function stateReducer(statePartial, whitelist, blacklist) {
  return Object.keys(statePartial).reduce((state, reducerKey) => {
    if (whitelist && !whitelist.includes(reducerKey)) return state;
    if (blacklist && blacklist.includes(reducerKey)) return state;
    state[reducerKey] = JSON.parse(statePartial[reducerKey]);
    return state;
  }, {});
}

export default crossTabEventFunction;
